import { ENTITY_TAB_POSTS_ORDERING_VALUE } from '../EntityTabPosts.constants'

export const ENTITY_TAB_POSTS_ORDERING_SELECT_OPTIONS = [
  {
    label: 'EntityTabPosts.OrderingDefaultKey',
    value: ENTITY_TAB_POSTS_ORDERING_VALUE.default,
  },
  {
    label: 'EntityTabPosts.OrderingNewestKey',
    value: ENTITY_TAB_POSTS_ORDERING_VALUE.newest,
  },
  {
    label: 'EntityTabPosts.OrderingOldestKey',
    value: ENTITY_TAB_POSTS_ORDERING_VALUE.oldest,
  },
]

export const QA_NAME_ENTITY_TAB_POSTS_ORDERING = 'entityTabPostsOrdering'
